import { ReactElement } from 'react';
import {
    Box, SimpleGrid, Text, Stack, Flex, useColorModeValue, Image,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
} from '@chakra-ui/react';

import d11 from '../assets/handdrawings/d11.png'
import d12 from '../assets/handdrawings/d12.png'
import d13 from '../assets/handdrawings/d13.png'
import d14 from '../assets/handdrawings/d14.png'
import d15 from '../assets/handdrawings/d15.png'
import d16 from '../assets/handdrawings/d16.png'
import d17 from '../assets/handdrawings/d17.png'
import d18 from '../assets/handdrawings/d18.png'
import d19 from '../assets/handdrawings/d19.png'
import d20 from '../assets/handdrawings/d20.png'
import d21 from '../assets/handdrawings/d21.png'
import d22 from '../assets/handdrawings/d22.png'
import d23 from '../assets/handdrawings/d23.png'
import d24 from '../assets/handdrawings/d24.png'
import d25 from '../assets/handdrawings/d25.png'
import d26 from '../assets/handdrawings/d26.png'
import d27 from '../assets/handdrawings/d27.png'
import d28 from '../assets/handdrawings/d28.png'
import d29 from '../assets/handdrawings/d29.png'
import d30 from '../assets/handdrawings/d30.png'
import d31 from '../assets/handdrawings/d31.png'
import d32 from '../assets/handdrawings/d32.png'
import d33 from '../assets/handdrawings/d33.png'
import d34 from '../assets/handdrawings/d34.png'
import d35 from '../assets/handdrawings/d35.png'
import d36 from '../assets/handdrawings/d36.png'
import d37 from '../assets/handdrawings/d37.png'
import d38 from '../assets/handdrawings/d38.png'

interface FeatureProps {
    title: string;
    text: string;
    icon: ReactElement;
}

const Feature = ({ title, text, icon }: FeatureProps) => {
    return (
        <Stack>
            <Flex
                align={'center'}
                justify={'center'}
                bg={useColorModeValue('white', 'gray.800')}
                mb={1}
                rounded={'2xl'}
            // boxShadow={'2xl'}
            >
                {icon}
            </Flex>
            <Text fontWeight={'thin'}
                textTransform='uppercase'
                color={useColorModeValue('black', 'white')}
                fontSize={'lg'}
                textAlign='center'
                letterSpacing={1}
            >{title}</Text>
            <Text
                color={useColorModeValue('gray.800', 'gray.200')}
                textAlign='center'
                fontSize={{ base: 'sm', lg: 'sm' }}
            >{text}
            </Text>
        </Stack>
    );
};

export default function Handdrawings() {
    return (
        <div id='handdrawings'>
            <Box mt={{ base: 20, md: 20 }}
                mx={'16px'}
            >
                <Text
                    textAlign={['center', 'center']}
                    pb={4}
                    fontSize={{base:'3xl',sm:'4xl'}}
                    letterSpacing={2}
                    color={useColorModeValue('black', 'white')}
                    fontWeight='thin'
                    textTransform='uppercase'
                    lineHeight='1'
                >
                    Hand Drawings</Text>

                <SimpleGrid columns={{ base: 2, md: 4 }} spacing={6}>

                    <Feature icon={
                        <Image
                            src={d11}
                            alt='handdrawing'
                            w={80}
                            rounded={'2xl'} />} />
                    <Feature icon={
                        <Image
                            src={d12}
                            alt='handdrawing'
                            w={80}
                            rounded={'2xl'} />} />
                    <Feature icon={
                        <Image
                            src={d13}
                            alt='handdrawing'
                            w={80}
                            rounded={'2xl'} />} />
                    <Feature icon={
                        <Image
                            src={d14}
                            alt='handdrawing'
                            w={80}
                            rounded={'2xl'} />} />
                </SimpleGrid>

                <Accordion allowToggle>
                    <AccordionItem>
                        <AccordionButton>
                            <Box as="span" flex='1' textAlign='left'>
                                <Text
                                    color='gray.400'
                                    fontSize='sm'
                                    fontWeight='light'
                                    lineHeight='0.9'
                                    mb={2}
                                >
                                    See more: Le Grand Tour en Chine 2018-2019</Text>
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={4}>
                            <SimpleGrid columns={{ base: 2, md: 4 }} spacing={6}>

                                <Feature
                                    icon={
                                        <Image
                                            src={d15}
                                            alt='handdrawing'
                                            w={80}
                                            rounded={'2xl'}
                                        />
                                    }
                                />
                                <Feature
                                    icon={<Image
                                        src={d16}
                                        alt='handdrawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />} />
                                <Feature
                                    icon={<Image
                                        src={d17}
                                        alt='renderings'
                                        w={80}
                                        rounded={'2xl'} />} />
                                <Feature
                                    icon={<Image
                                        src={d18}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d19}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d20}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d21}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d22}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d23}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d24}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d25}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d26}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d27}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d28}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d29}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d30}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d31}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d32}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d33}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d34}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d35}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d36}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d37}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                                <Feature
                                    icon={<Image
                                        src={d38}
                                        alt='hand drawings'
                                        w={80}
                                        rounded={'2xl'}
                                    />}
                                />
                            </SimpleGrid>
                        </AccordionPanel>
                    </AccordionItem>
                </Accordion>

            </Box>
        </div>
    );
}